<template>
    <div class="nextConference">
        <div class="coverGrid" v-if="conference.cover">
            <div class="cover">
                <div class="filler"></div>
                <Image :image="conference.cover" :width="600" :height="400" :mobileWidth="824" :mobileHeight="550" imageClass="cover" />
            </div>
        </div>
        <div class="conferenceHeader">
            <div class="helvetica title1">{{ conference.title }}</div>
            <LazyNeverItemConferenceSubtitle :page="conference" hydrate-never />
            <div class="topic bodyL">{{ conference.topic }}</div>
            <div class="summary">{{ conference.summary }}</div>
        </div>
        <div class="buttonCont">
            <NuxtLink :to="{ name: 'conferences-slug', params: { slug: conference.url } }" :custom="true">
                <template v-slot="{ navigate }">
                    <NButton type="secondary" size="large" @click="navigate">Join</NButton>
                </template>
            </NuxtLink>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { NButton } from 'naive-ui'
const props = defineProps<{ conference: any }>()
</script>

<style lang="scss" scoped>
.nextConference {
    display: flex;
    flex-direction: column;
    gap: var(--size-gutter-double);

    .coverGrid {
        display: grid;
        grid-template-columns: 5fr 5fr 2fr;

        .cover {
            width: 100%;
            background-color: #fafafa;
            position: relative;

            .filler {
                padding-top: 66.667%;
            }

            &:deep(.responsivePicture) {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
            }
        }
    }

    .conferenceHeader {
        display: flex;
        flex-direction: column;

        .topic {
            margin: var(--size-gutter-double) 0 var(--size-gutter-default) 0;
            color: var(--color-primary);
            font-weight: bold;
        }
    }

    .summary {
        max-width: var(--text-maxwidth-body);
    }
}

@media screen and (max-width: 1024px) {
    .nextConference {
        .coverGrid {
            grid-template-columns: 2fr 1fr;
        }
    }
}

@media screen and (max-width: 600px) {
    .nextConference {
        .coverGrid {
            grid-template-columns: 1fr;
        }
    }
}
</style>